import * as React from 'react';
import { IDataEntity, IAppParams } from '../../models';
import { isPrint } from "../../utils";

// tslint:disable-next-line:variable-name
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const styles = require('../FundPages/Fundpages.pcss');

interface IExplorerFundRowState {
    Opened?: boolean;
}

export class ExplorerFundRow extends React.Component<React.Props<{}> & { fund: IDataEntity, toggleRows: any, colSpan: number, appParams: IAppParams }, IExplorerFundRowState>{
    constructor(props) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);

    }

    handleToggle() {
        let { fund, toggleRows } = this.props;
        toggleRows(fund, !fund.collapsed);
    }

    render() {
        let { fund, colSpan, appParams } = this.props;
        let activeRow = !fund.collapsed ? styles.active : '';
        let internalClasses = {
            //reveal: this.state.Opened == true ? styles.show : styles.hide,
            active: `${styles.dropdownbutton} ${activeRow}`,
        };

        return (

            <tr className={styles.tableAccordionHeader}>
                <td colSpan={colSpan || 15} className={styles.first}>
                    <a className={styles.firstRowHyperLink} onClick={this.handleToggle}>
                        {!isPrint(appParams) && <button type="button" className={internalClasses.active}><FaAngleDown /></button>}
                        {fund.properties["fund_name"]} <span className={styles.shareClassCountIndicator}>({fund.shareClasses ? fund.shareClasses.length : 0})</span>
                    </a>
                </td>
            </tr>

        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/ExplorerFundRow/ExplorerFundRow.tsx